<template>
  <header class="site-header">
    <div class="site-header-inner">
      <a href="#home" class="logo" @click.prevent="scrollToSection('home')">
        <span class="logo-soon">SOON</span><span class="logo-forward">FORWARD</span>
      </a>

      <nav class="nav-options">
        <a href="#partners" @click.prevent="scrollToSection('partners')">Partners</a>
        <a href="#approach" @click.prevent="scrollToSection('approach')">Approach</a>
        <a href="#vision" @click.prevent="scrollToSection('vision')">Vision</a>
      </nav>

      <a href="#demo" class="btn btn-primary btn-sm"
      @click.prevent="scrollToSection('demo')">Book a demo</a>

      <button
        type="button"
        class="nav-toggle"
        :class="{ 'nav-toggle--open': isMenuOpen }"
        :aria-label="isMenuOpen ? 'Close menu' : 'Open menu'"
        :aria-expanded="isMenuOpen"
        @click="toggleMenu"
      >
        <div class="nav-toggle-bars">
          <span class="nav-toggle-bar nav-toggle-bar--top"></span>
          <span class="nav-toggle-bar nav-toggle-bar--mid"></span>
          <span class="nav-toggle-bar nav-toggle-bar--bottom"></span>
        </div>
      </button>
    </div>

    <div class="nav-overlay" :class="{ 'nav-overlay--open': isMenuOpen }">
      <nav class="nav-overlay-options">
        <a href="#partners" @click.prevent="selectSection('partners')">Partners</a>
        <a href="#approach" @click.prevent="selectSection('approach')">Approach</a>
        <a href="#vision" @click.prevent="selectSection('vision')">Vision</a>
      </nav>
    </div>
  </header>
</template>

<script>
import scrollToSectionUtil from '../utils/scrollToSection';
import '../assets/styles/landing-shared.scss';

export default {
  name: 'Landing2Navbar',
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    scrollToSection: scrollToSectionUtil,
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    selectSection(id) {
      this.isMenuOpen = false;
      this.scrollToSection(id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/fluid';

.site-header {
  max-width: 85rem;
  margin: 1.5rem auto 0;
}

.site-header-inner {
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 5rem;
  padding: 0 4rem;
  background: var(--color-white);
  border-radius: 2rem 2rem 0 0;
}

.nav-options {
  flex: 0 0 auto;
  display: flex;
  gap: var(--nav-gap);
}

.nav-options a {
  font-size: var(--font-size-nav);
  font-weight: 500;
  line-height: 1.1875rem;
  color: var(--color-text);
  text-decoration: none;
  white-space: nowrap;
}

.nav-toggle {
  display: none;
  flex: 0 0 auto;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.nav-toggle-bars {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 2rem;
  height: 1.5rem;
}

.nav-toggle-bar {
  display: block;
  height: 0.25rem;
  border-radius: 0.625rem;
  background: var(--color-text);
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.nav-toggle-bar--mid {
  width: 75%;
  margin-left: auto;
}

/* morphs the three bars into an X  */
.nav-toggle--open .nav-toggle-bar--top {
  transform: translateY(0.625rem) rotate(45deg);
}

.nav-toggle--open .nav-toggle-bar--mid {
  opacity: 0;
}

.nav-toggle--open .nav-toggle-bar--bottom {
  transform: translateY(-0.625rem) rotate(-45deg);
}

.nav-overlay {
  display: none;
}

/* the hamburger drawer covers the full viewport. */
@media (max-width: 1439px) {
  .nav-overlay {
    position: fixed;
    inset: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-white);
    transform: translateX(100%);
    transition: transform 0.35s ease;
  }

  .nav-overlay--open {
    transform: translateX(0);
  }

  .nav-overlay-options {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: fluid(2rem, 3rem);
    opacity: 0;
    transition: opacity 0.25s ease;
  }

  .nav-overlay--open .nav-overlay-options {
    /* fades in only once the slide is mostly finished */
    transition-delay: 0.2s;
    opacity: 1;
  }

  .nav-overlay-options a {
    font-size: fluid(1.5rem, 2rem);
    font-weight: 600;
    color: var(--color-text);
    text-decoration: none;
  }
}

@media (max-width: 767px) {
  .site-header {
    max-width: none;
    margin: 0;
  }

  .site-header-inner {
    height: 4rem;
    padding: 0 1.5rem;
    border-radius: 0;
  }

  .nav-options,
  .site-header-inner > .btn {
    display: none;
  }

  .nav-toggle {
    position: relative;
    display: flex;
  }

  /* expands the tap target to ~48px without resizing the visible icon */
  .nav-toggle::before {
    content: '';
    position: absolute;
    top: -0.75rem;
    right: -0.75rem;
    bottom: -0.75rem;
    left: -0.75rem;
  }
}

@media (min-width: 768px) and (max-width: 1439px) {
  .site-header {
    max-width: none;
    margin: 0;
  }

  .site-header-inner {
    height: fluid(4rem, 5rem);
    padding: 0 fluid(1.5rem, 4rem);
    border-radius: 0;
  }

  .nav-options,
  .site-header-inner > .btn {
    display: none;
  }

  .nav-toggle {
    position: relative;
    display: flex;
  }

  .nav-toggle::before {
    content: '';
    position: absolute;
    top: -0.75rem;
    right: -0.75rem;
    bottom: -0.75rem;
    left: -0.75rem;
  }
}
</style>
